// extracted by mini-css-extract-plugin
export default {"sortControl":"sort_sortControl__VTWtC","sortLabel":"sort_sortLabel__VE5Ry","sortSelect":"sort_sortSelect__DqY-c"};